<template>
  <layout-admin-dashboard-view
    class="relative"
    :show-toolbar="false"
    :back-route="{ name: 'admin-landingPage' }">
    <template #title>
      <span>{{ translateTitleCase("lp.admin.lpEdit.title") }}</span>
    </template>

    <template #default>
      <block class="relative">
        <div
          class="floater round z-level-top-3 circle flex-middle flex-center fixed"
          v-if="!isFormStateValid"
          style="inset-inline-end: 20px; top: calc(50% - 25px)">
          <div class="flex-column flex-middle flex-center gap-s text-center">
            <icon-halo
              v-tooltip="{
                content: 'lp.admin.duplicateSectionErrorNotification',
              }"
              halo-theme="danger"
              theme="bg"
              size="2"
              icon="warning-triangle"></icon-halo>
          </div>
        </div>
        <spinner v-if="!isFormReady" overlay="absolute"></spinner>
        <custom-crud-edit
          v-bind="editConfiguration"
          @item:updated="handleItemUpdated">
          <template #top-actions="{ itemData }">
            <div>
              <form-button
                theme="inverse"
                icon="eye"
                @click="previewPage(itemData)"
                text="lp.admin.preview.text"></form-button>
            </div>
          </template>
        </custom-crud-edit>
      </block>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudEdit from "@/client/components/crud/customV1/Edit.vue";
import useLandingPage from "@/client/applications/meitavlp/extensions/composition/useLandingPage";

import { computed } from "vue";
import _ from "lodash";

export default {
  components: { CustomCrudEdit },
  layout: "adminDashboard",

  middleware: {
    requireSuperAdmin: {},
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let { landingPageForm } = useLandingPage(props);

    return {
      asyncOps,
      asyncOpsReady,
      asyncStatus,
      landingPageForm,
    };
  },
  meta: "lp.admin.lpEdit.pageTitle",
  data: function () {
    return {
      isFormReady: computed(() => this.landingPageForm.isReady),
      initialFormLoaded: false,
      editConfiguration: {
        subject: "landingPage",
        routePrefix: "landingPage/",
        itemSrc: computed(() => {
          return "landingPage/admin/" + this.id;
        }),
        submitUrl: computed(() => {
          return "landingPage/" + this.id;
        }), // default: shine/[name]
        duplicateUrl: "landingPage/",
        duplicationSanitizer: async (data) => {
          data.name = data?.name + "-" + new Date().getTime();
          data.title = data?.title + "-" + new Date().getTime();
          data.alias = data?.alias + "_1";
          let sectionKeys = data.sectionTypeList.map((item) => item.type);
          sectionKeys.forEach((key) => {
            delete data[key].id;
          });
          return data;
        },
        submitMethod: "patch", //default 'patch'
        cancelRedirect: { name: "admin-landingPage" },
        successRedirect: { name: "admin-landingPage" },
        itemId: this.id,
        itemMapper: async (data) => {
          return data;
        },
        formConfig: computed(() => this.landingPageForm.config),
      },
      lastTypes: null,
      asyncData: {},
      isFormStateValid: true,
    };
  },
  computed: {},
  methods: {
    previewPage(item) {
      let name = `landing-categoryAlias-lpAlias`;
      let params = {
        categoryAlias: item?.Category?.alias,
        lpAlias: item?.alias,
      };
      let query = {
        //  isPreview: true,
      };

      let resolved = this.$router.resolve({ name, params, query });
      window.open(resolved.href, "_blank");
    },
    handleItemUpdated({ itemData, oldData }) {
      let targetTypes = Array.isArray(itemData.sectionTypeList)
        ? itemData.sectionTypeList
        : [];

      let simpleTypeList = [];
      let hasDuplicate = false;
      targetTypes.filter((item) => {
        if (
          simpleTypeList.includes(item.type) &&
          utilities.isNonEmptyString(item.type)
        ) {
          hasDuplicate = true;
          return false;
        }
        simpleTypeList.push(item.type);
      });

      if (hasDuplicate) {
        this.$s.ui.notification(
          "lp.admin.duplicateSectionErrorNotification",
          "error"
        );
        this.isFormStateValid = false;
        return false;
      } else {
        this.isFormStateValid = true;
      }
      // if this is the first data that we get, update the form (force)
      if (!this.initialFormLoaded) {
        this.initialFormLoaded = true;
        this.landingPageForm.adjustTypes(targetTypes, true);
        return;
      }

      // if the update doesnt require type adjustment, just note that and we are done
      if (targetTypes === this.lastTypes) {
        this.landingPageForm.adjustTypes(targetTypes);
      } else {
        this.landingPageForm.adjustTypes(targetTypes, true);
      }

      this.lastTypes = targetTypes;

      // update the section order field
      let index = 0;
      let sectionTypeKeys = itemData.sectionTypeList
        .filter((item) => typeof item.type === "string")
        .map((item) => item.type);
      sectionTypeKeys.forEach((type) => {
        if (!itemData[type]) {
          return true;
        }

        if (itemData[type].sectionOrder !== index) {
          itemData[type].sectionOrder = index;
        }

        index = index + 1;
        if (typeof itemData[type].state === "undefined") {
          itemData[type].state = 1;
        }

        if (typeof itemData[type].OwnerId === "undefined") {
          itemData[type].OwnerId = this.sg("user.profile")?.id;
        }
      });

      // update the state and owner
    },
  },
};
</script>

<style scoped lang="scss"></style>
